// extracted by mini-css-extract-plugin
export default {"page":"App_page__J1BDI","content":"App_content__IVGBn","home":"App_home__+Qjxk"};